import { throwError } from "@lib/throwError";
import { get, post, put } from "@/services/axiosUitils";
import { PaginatedResponse } from "@/utils/types/tenantPermissions";
import { getTenantUserById, TenantUser } from "@/utils/types/tenantUser";

const base = "/users/";

class TenantUserService {
  listTenantUsers = async (
    page = 1,
    page_size = 20
  ): Promise<PaginatedResponse<TenantUser>> => {
    return await get<PaginatedResponse<TenantUser>>(base, {
      params: { page, page_size },
    });
  };

  getTenantUserById = async (id: string): Promise<getTenantUserById> => {
    if (!id) {
      throwError("ID is required", "TenantUserService");
    }
    return await get<getTenantUserById>(`${base}${id}/`);
  };

  createUser = async (user: TenantUser): Promise<TenantUser> => {
    return await post<TenantUser>(base, user);
  };

  updateUser = async (id: string, user: TenantUser): Promise<TenantUser> => {
    return await put<TenantUser>(`${base}${id}/`, user);
  };
}

const instance = new TenantUserService();
export default instance;
